"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringHasValue = exports.navigationTracking = exports.getQueryParamsAsString = exports.calculateAspectRatioFit = exports.browserDetect = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var stringHasValue = exports.stringHasValue = function stringHasValue() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return val && val !== null && val !== undefined && typeof val === 'string' && val.trim() !== '';
};
var browserDetect = exports.browserDetect = {
  get isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  },
  get isEdge() {
    return window.navigator.userAgent.indexOf('Edge') > -1;
  }
};
var getQueryParamsAsString = exports.getQueryParamsAsString = function getQueryParamsAsString(params) {
  return !_lodash["default"].isEmpty(params) ? "?".concat(_lodash["default"].map(params, function (param, key) {
    return "".concat(key, "=").concat(param);
  }).join('&')) : '';
};

/**
 * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
 * images to fit into a certain area.
 * From: https://stackoverflow.com/a/14731922/1978835
 *
 * @param {Number} srcWidth width of source image
 * @param {Number} srcHeight height of source image
 * @param {Number} maxWidth maximum available width
 * @param {Number} maxHeight maximum available height
 * @return {Object} { width, height }
 */
var calculateAspectRatioFit = exports.calculateAspectRatioFit = function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
  var scale = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
  return {
    scale: scale,
    width: srcWidth * scale,
    height: srcHeight * scale
  };
};

/**
 * @description keeps track of the last N urls visited by the client
 */
var navHistory = /*#__PURE__*/function () {
  function navHistory() {
    var _this = this;
    _classCallCheck(this, navHistory);
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "maxLength", 5);
    _defineProperty(this, "add", function (item, isRefresh) {
      item = encodeURI(item);
      if (_this.first === item && !isRefresh) return;
      if (_this.size > _this.maxLength - 1) _this.remove();
      _this.data.unshift(item);
    });
    _defineProperty(this, "remove", function () {
      _this.data.pop();
    });
    this.data = [];
  }
  return _createClass(navHistory, [{
    key: "first",
    get: function get() {
      return this.data[0];
    }
  }, {
    key: "referrerUrl",
    get: function get() {
      return this.size === 1 ? this.first : this.data[1];
    }
  }, {
    key: "size",
    get: function get() {
      return this.data.length;
    }
  }]);
}();
var navigationTracking = exports.navigationTracking = new navHistory();
//# sourceMappingURL=generic-utils.js.map